import React from "react";
import { useData } from "../../context/DataContext";
const Footer = () => {
  const icons = [1, 2, 3, 4, 5];
  const data = useData();
  return (
    <footer className="py-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 text-center">
            {icons
              .map((el) => data[`social_icon_${el}`])
              .map((el, i) => (
                el?.icon?.[0] && <div className="d-inline-block mx-2" key={i}>
                  <a href={el.link} className="">
                      <img
                        alt={el.icon_name}
                        src={el.icon?.[0].src}
                        style={{ width: "28px", height: "28px" }}
                      />
                  </a>
                </div>
              ))}
          </div>
          <div className="w-100 my-3"></div>
          <div className="col-lg-12">
            <h5 className="text-center">{data.website_details.website_name}</h5>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
